import React from 'react'
import { MaintenanceRouteImport } from './Imports'
const { RoutesMap, AddMaintenance, PreventiveMaintenanceList, CorrectiveMaintenanceList, JobCardList, MaintenanceHierarchy, StaffMaintenanceHierarchy } = MaintenanceRouteImport

const MaintenanceRoute = () => {
    return [
        {
            path: RoutesMap.ADD_MAINTENANCE.path,
            element: <AddMaintenance />
        },
        {
            path: RoutesMap.PREVENTIVE_MAINTENANCE_LIST.path,
            element: <PreventiveMaintenanceList />
        },
        {
            path: RoutesMap.CORRECTIVE_MAINTENANCE_LIST.path,
            element: <CorrectiveMaintenanceList />
        },
        {
            path: RoutesMap.JOB_CARD_LIST.path,
            element: <JobCardList />
        },
        // {
        //     path: RoutesMap.JOB_ORDER_DETAIL.path,
        //     element: <JobOrderDetails />
        // },


        {
            path: RoutesMap.MAINTAINANCE_HIERARCHY.path,
            element: <MaintenanceHierarchy />
        },

        {
            path: RoutesMap.STAFF_MAINTENANCE_HIERARCHY.path,
            element: <StaffMaintenanceHierarchy />
        },
    ]
}

export default MaintenanceRoute;